import { mapGetters, mapMutations } from 'vuex';
import { ProgressFooterToolbar } from 'ipro-ui-kit-vuejs/src/components';

import { ActionOnPageFocusMixin } from '@/core/mixins';
import { WorkerInductionService, WorkerInductionConstants } from '@/core/worker-induction';
import { WorkerOneTimePassService } from '@/core/worker-one-time-pass';
import { OneTimePassRoutesMixin } from '@/portal/one-time-pass/mixins';

// @vue/component
export default {
  components: {
    ProgressFooterToolbar,
  },
  mixins: [
    ActionOnPageFocusMixin,
    OneTimePassRoutesMixin,
  ],
  data() {
    return {
      intervalWhileFocused: 6000,
      requestInProgress: false,
      workerInduction: {},
      preHeadingText: '',
    };
  },
  computed: {
    ...mapGetters('oneTimePass', ['filteredAssessmentFields', 'workerInductions']),
    ...mapGetters('oneTimePass', {
      clientName: 'oneTimePassClientName',
    }),
    expiryPeriod() {
      return (this.workerInduction.expiry_period || '').replace('.', ' ');
    },
    inductionUuid() {
      return this.$route.params.inductionUuid || _.get(this.workerInductions[0], 'uuid');
    },
    inductionStep() {
      return this.workerInductions.findIndex(workerInduction => _.get(workerInduction, 'uuid') === this.inductionUuid) + 1;
    },
    isCompleted() {
      return _.get(this.workerInduction, 'current_status') === _.get(WorkerInductionConstants, 'current_status.completed.key');
    },
  },
  created() {
    this.fetchWorkerInduction();
    this.updatePreHeadingText();
  },
  methods: {
    ...mapMutations('oneTimePass', ['setWorkerOneTimePass']),
    async fetchWorkerInduction() {
      this.requestInProgress = true;
      this.workerInduction = await WorkerInductionService.get(this.inductionUuid);
      this.requestInProgress = false;
    },
    updatePreHeadingText() {
      this.preHeadingText = `Requirement ${this.inductionStep}/${this.workerInductions.length}`;
    },
    goToInduction(inductionUuid) {
      this.$router.push(_.merge({}, this.routes.induction, {
        params: { inductionUuid },
      }));
    },
    nextInduction() {
      const nextInduction = this.workerInductions[this.inductionStep];

      if (nextInduction) {
        this.goToInduction(nextInduction.uuid);
      } else {
        this.setWorkerOneTimePass(null);
        WorkerOneTimePassService.clearCache();
        this.$router.push(this.routes.reviewApplication);
      }
    },
    openInductionInNewTab() {
      const redirectUrl = encodeURIComponent(window.location.href);
      const workerInductionUrl = _.get(this.workerInduction, 'induction_url');
      const urlHasQueryParams = workerInductionUrl.includes('?');
      const resolvedUrl = `${workerInductionUrl}${urlHasQueryParams ? '&' : '?'}redirect_to=${redirectUrl}`;
      window.open(resolvedUrl, '_blank');
    },
    previousInduction() {
      const previousInduction = this.workerInductions[this.inductionStep - 2];

      if (previousInduction) {
        this.goToInduction(previousInduction.uuid);
      } else {
        this.setWorkerOneTimePass(null);
        WorkerOneTimePassService.clearCache();
        this.$router.push(this.routes.criteriaSummary);
      }
    },
    performActionIfFocused() {
      if (!this.isCompleted) {
        this.fetchWorkerInduction();
      }
    },
  },
};
